import Logo from "@/components/base/Logo";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    { label: "Réparation volet roulant", href: "/reparation-volet-roulant", icon: "ri-tools-line" },
    { label: "Dépannage urgence", href: "/depannage-urgence", icon: "ri-alarm-warning-line" },
    { label: "Remplacement de moteur", href: "/moteur-somfy", icon: "ri-flashlight-line" },
    { label: "Motorisation", href: "/motorisation-somfy", icon: "ri-remote-control-line" },
    { label: "Électrification", href: "/electrification-somfy", icon: "ri-flashlight-line" },
    { label: "Pose & installation", href: "/pose-volet-roulant", icon: "ri-add-circle-line" },
    { label: "Sangle & cordon", href: "/sangle-volet-roulant", icon: "ri-scissors-cut-line" },
    { label: "Tablier & lames", href: "/tablier-volet-roulant", icon: "ri-window-line" },
  ];

  const villes = [
    { label: "Strasbourg", href: "/", icon: "ri-map-pin-line" },
    { label: "Haguenau", href: "/haguenau", icon: "ri-map-pin-line" },
    { label: "Schiltigheim", href: "/schiltigheim", icon: "ri-map-pin-line" },
    { label: "Illkirch-Graffenstaden", href: "/illkirch-graffenstaden", icon: "ri-map-pin-line" },
    { label: "Sélestat", href: "/selestat", icon: "ri-map-pin-line" },
    { label: "Lingolsheim", href: "/lingolsheim", icon: "ri-map-pin-line" },
    { label: "Obernai", href: "/obernai", icon: "ri-map-pin-line" },
    { label: "Molsheim", href: "/molsheim", icon: "ri-map-pin-line" },
    { label: "Toutes les villes", href: "/zones-d-intervention", icon: "ri-map-2-line" },
  ];

  const marques = [
    { label: "Somfy", href: "/moteur-somfy" },
    { label: "Nice", href: "/moteur-nice" },
    { label: "Simu", href: "/moteur-somfy" },
    { label: "Bubendorff", href: "/moteur-bubendorff" },
    { label: "Profalux", href: "/moteur-profalux" },
    { label: "Elero", href: "/moteur-somfy" },
  ];

  return (
    <footer id="contact" className="bg-[#143A66] text-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Colonne 1 — Marque */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <Logo light />
            </div>
            <p className="text-[#E2E8F0] text-sm leading-relaxed mb-4">
              <strong className="text-white">Dépan'Volets</strong> répare, motorise et pose des volets roulants à Strasbourg et dans tout le Bas-Rhin. <strong className="text-white">Intervention 24h</strong>, <strong className="text-white">devis gratuit</strong>, toutes marques.
            </p>
            <p className="text-[#9DB2C8] text-xs leading-relaxed">
              <span className="text-[#E2E8F0]">Toutes marques :</span>{" "}
              {marques.map((m, i) => (
                <span key={m.label}>
                  <a
                    href={m.href}
                    className="text-[#E2E8F0] hover:text-[#00B3A4] transition-colors underline underline-offset-2 decoration-[#9DB2C8]/40 hover:decoration-[#00B3A4]"
                  >
                    {m.label}
                  </a>
                  {i < marques.length - 1 ? ", " : "."}
                </span>
              ))}
            </p>
          </div>

          {/* Colonne 2 — Nos services */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Nos services
            </h4>
            <ul className="grid grid-cols-2 sm:grid-cols-1 gap-x-4 gap-y-2.5">
              {services.map((s) => (
                <li key={s.href}>
                  <a
                    href={s.href}
                    className="inline-flex items-center gap-2 text-[#E2E8F0] text-sm hover:text-[#00B3A4] transition-colors min-w-0"
                  >
                    <span className="w-5 h-5 flex items-center justify-center text-[#00B3A4]">
                      <i className={`${s.icon} text-sm`}></i>
                    </span>
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 3 — Zones d'intervention */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Zones d'intervention
            </h4>
            <ul className="grid grid-cols-2 sm:grid-cols-1 gap-x-4 gap-y-2.5">
              {villes.map((v) => (
                <li key={v.href}>
                  <a
                    href={v.href}
                    className="inline-flex items-center gap-2 text-[#E2E8F0] text-sm hover:text-[#00B3A4] transition-colors min-w-0"
                  >
                    <span className="w-5 h-5 flex items-center justify-center text-[#00B3A4]">
                      <i className={`${v.icon} text-sm`}></i>
                    </span>
                    {v.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 4 — Contact */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-3 text-sm">
              <p className="text-[#E2E8F0] leading-relaxed">
                <span className="text-[#9DB2C8] text-xs uppercase tracking-wider block mb-0.5">Atelier</span>
                82 Rue de Heidenberg<br />67200 Strasbourg
              </p>
              <p>
                <span className="text-[#9DB2C8] text-xs uppercase tracking-wider block mb-0.5">Téléphone</span>
                <a href="tel:0374473240" className="text-white font-semibold text-base hover:text-[#00B3A4] transition-colors">
                  03 74 47 32 40
                </a>
              </p>
              <p className="text-[#E2E8F0] leading-relaxed">
                <span className="text-[#9DB2C8] text-xs uppercase tracking-wider block mb-0.5">Horaires</span>
                Lun–Ven 8h–19h<br />Sam 8h–12h
              </p>
            </div>
            <a
              href="/contact"
              className="inline-flex items-center mt-5 px-5 py-2.5 bg-[#00B3A4] text-white text-sm font-semibold rounded-md hover:bg-[#00B3A4]/90 transition-colors min-w-0"
            >
              Devis gratuit
            </a>
            <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1">
              <a href="/contact" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">Contact</a>
              <a href="/tarifs" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">Tarifs</a>
              <a href="/avis" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">Avis</a>
            </div>
          </div>
        </div>
      </div>

      {/* Barre du bas */}
      <div className="bg-[#0F2E52]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-[#9DB2C8] text-xs text-center sm:text-left">
              © {currentYear} DF PRO — <strong className="text-[#9DB2C8]">Dépan'Volets Strasbourg</strong>. Tous droits réservés.
            </p>
            <div className="flex gap-5">
              <a href="/mentions-legales" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">
                Mentions légales
              </a>
              <a href="/politique-confidentialite" className="text-[#9DB2C8] text-xs hover:text-[#00B3A4] transition-colors">
                Politique de confidentialité
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}